
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { component as Viewer } from 'v-viewer';
// import moment from 'moment';
import { BASE_URL } from '@/common/constant';
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import SupplyService from '@/services/supply.service';

@Component({
  components: {
    Viewer,
  },
})
export default class RegisterDeliveryModal extends Vue {
  visible = false;

  loading = false;

  uploading = false;

  record: any = null;

  BASE_URL = BASE_URL;

  token: string | undefined = undefined;

  @lazyInject(UserService)
  userService!: UserService;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  form: any = {
    tracking_number: '',
    shipment_date: '',
    arrival_date: '',
    fileList: [] as any[],
  };

  rules: any = {
    tracking_number: [
      { required: true, message: '请输入发货单号', trigger: 'blur' },
    ],
    shipment_date: [
      { required: true, message: '请选择发货时间', trigger: 'change' },
    ],
  };

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  created() {
    this.token = this.userService.currentUser()?.token;
  }

  open(record: any) {
    this.record = record || null;
    this.form = {
      tracking_number: '',
      shipment_date: '',
      arrival_date: '',
      fileList: [],
    };
    this.visible = true;
    this.$nextTick(() => {
      this.ruleForm && this.ruleForm.clearValidate('');
    });
  }

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于 5MB!');
    }
    return isJpgOrPng && isLt5M;
  }

  async onUploadChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
      return;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response || {};
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: { redirect: this.$route.fullPath },
        });
      } else {
        this.$message.error(error || '上传失败');
      }
      return;
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      this.form.fileList.push({
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'delivery.png',
        status: 'done',
      });
      this.uploading = false;
    }
  }

  delVoucher(index: number) {
    this.form.fileList.splice(index, 1);
  }

  handleOk() {
    this.ruleForm.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      this.loading = true;

      const ids = this.form.fileList.map((f: any) => f.id);
      const params = {
        sppo_id: this.record.id,
        tracking_number: this.form.tracking_number,
        shipment_date: this.form.shipment_date,
        arrival_date: this.form.arrival_date,
        resource_no: ids.join(','),
      };
      const res = await this.supplyService.postPlatOrderShip(params);
      if (res) {
        this.$message.success('登记发货成功');
        this.visible = false;
        this.$emit('refresh');
      }
      this.loading = false;
    });
  }

  handleCancel() {
    this.visible = false;
    this.form.fileList = [];
    this.ruleForm.resetFields();
  }
}
